import React from 'react';
import { Trans } from 'react-i18next';
import classnames from 'classnames';
import DeviationDumbView from '../../Dumbo/';
import DeviationLink from '../../../Duperbrowse/DeviationLink';
import { Comment as CommentControl, Fave as FaveControl, } from '../Standard/Overlay/OverlayControls';
import UserAvatar from '../../../User/Avatar';
import UserLink from '../../../User/Link';
import { AuthorWatchButton } from '../../../Button';
import DailyDevInfo from './DailyDevInfo';
import { getDeviationType } from '../../_helpers';
import ErrorBoundary from '../../../ErrorBoundary';
import OverlayContext from '../Standard/Overlay/OverlayContext';
import ExcerptRenderer from '../../../TextRenderer/ExcerptRenderer';
import { IconSize } from '../../../Icons/IconWrap';
import s from './DailyDev.scss';
export var DesktopDailyDev = function (_a) {
    var _b = _a.deviation, title = _b.title, textContent = _b.textContent, author = _b.author, dailyDeviation = _b.dailyDeviation, deviation = _a.deviation, width = _a.width, height = _a.height, showMatureContent = _a.showMatureContent;
    var isLiterature = getDeviationType(deviation) === 'literature';
    var typeMap = {
        NANO: 'nano',
        MICRO: 'micro',
        SMALL: 'small',
        MEDIUM: 'medium',
        BIG: 'big',
    };
    var typeSizeMap = {
        NANO: 250,
        MICRO: 329,
        SMALL: 410,
        MEDIUM: 424,
        BIG: 612,
    };
    function getTypeBasedOnSize(size) {
        if (size < typeSizeMap.NANO) {
            return typeMap.NANO;
        }
        if (size <= typeSizeMap.MICRO) {
            return typeMap.MICRO;
        }
        if (size <= typeSizeMap.SMALL) {
            return typeMap.SMALL;
        }
        if (size > typeSizeMap.MEDIUM) {
            return typeMap.BIG;
        }
        return typeMap.MEDIUM;
    }
    var type = getTypeBasedOnSize(height || width);
    var hideContent = (!showMatureContent && deviation.isMature) || deviation.isBlocked;
    return (React.createElement("div", { className: classnames(s['root'], s[type], isLiterature && s['literature']), style: { width: width, height: height } },
        React.createElement(ErrorBoundary, null,
            React.createElement(OverlayContext.Consumer, null, function (_a) {
                var _b = _a.showFaveControl, showFaveControl = _b === void 0 ? true : _b, _c = _a.showCommentControl, showCommentControl = _c === void 0 ? true : _c, _d = _a.showAuthor, showAuthor = _d === void 0 ? true : _d, _e = _a.showAuthorTooltip, showAuthorTooltip = _e === void 0 ? true : _e, _f = _a.showTitle, showTitle = _f === void 0 ? true : _f;
                return (React.createElement(React.Fragment, null,
                    React.createElement(DeviationLink, { deviation: deviation, className: s['link'], title: title },
                        React.createElement(DeviationDumbView, { deviation: deviation, width: width, height: height, allowPreviewUsage: true, useTextlessMode: true })),
                    React.createElement("div", { className: s['fade'] }),
                    React.createElement("div", { className: s['overlay'] },
                        React.createElement("div", { className: s['info'] },
                            showTitle && React.createElement("div", { className: s['title'] }, title),
                            isLiterature && !hideContent && (React.createElement(ExcerptRenderer, { className: s['text-content'], textContent: textContent })),
                            showAuthor && author && (React.createElement("div", { className: s['attribution'] },
                                React.createElement("div", null,
                                    React.createElement(UserAvatar, { className: s['avatar'], size: 40, user: author, withTooltip: showAuthorTooltip, relatedItemBiData: {
                                            typeid: deviation.typeId,
                                            itemid: deviation.deviationId,
                                        } })),
                                React.createElement("div", { className: s['author'] },
                                    React.createElement("div", null,
                                        React.createElement(Trans, { i18nKey: "deviationview.dailydev.author" },
                                            React.createElement("span", { className: s['dd-by'] }, "By "),
                                            React.createElement(UserLink, { className: s['user-link'], user: author, withTooltip: showAuthorTooltip, biData: {
                                                    creatorid: author.useridUuid,
                                                }, relatedItemBiData: {
                                                    typeid: deviation.typeId,
                                                    itemid: deviation.deviationId,
                                                } }))),
                                    React.createElement(AuthorWatchButton, { author: author, className: s['watch'] })))),
                            dailyDeviation && (React.createElement(DailyDevInfo, { dailyDeviation: dailyDeviation }))),
                        React.createElement("div", { className: s['controls'] },
                            showCommentControl && (React.createElement(CommentControl, { size: IconSize.COMPACT, deviation: deviation, className: s['stat'], iconClassName: s['stat-icon'] })),
                            showFaveControl && (React.createElement(FaveControl, { size: IconSize.COMPACT, deviation: deviation, className: s['stat'], iconClassName: classnames(s['stat-icon'], s['fave-icon']) }))))));
            }))));
};
DesktopDailyDev.displayName = 'DesktopDailyDev';
export default DesktopDailyDev;
//# sourceMappingURL=DesktopDailyDev.js.map